///<reference path="../../model/AppState.ts"/>
///<reference path="./HorizontalScrollerBase.ts"/>

namespace khi.bk117.view.parts
{
	import Debugger = com.enirva.debug.Debugger;

	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Sprite = com.enirva.display.Sprite;
	import Tween = com.enirva.tween.Tween;
	import AppState = khi.bk117.model.AppState;
	import HorizontalScrollerBase = khi.bk117.view.parts.HorizontalScrollerBase;

	/*
   * 横スクロールのカルーセル処理
   * 汎用的に使えるように改良
	 */
	export class HorizontalScroller extends HorizontalScrollerBase
	{
		private bar:JQuery;

		private timer:number;

		private scrollPer:number;

		private indicatorsPc:JQuery[];

		private indicatorsSp:JQuery[];
		
		//private slidePhotoContainer:Sprite;

    private locked:boolean;
    
		private targetStr:string;

		//画面に一度に表示されるアイテムの数
		private showNum:number;

		//画面に一度に表示されるアイテムの数
		private showNumPc:number;

		private scrollBarPer:number;

		private itemWidth:number;


		//オプション設定

		//切り替わりの秒数
		public limitTime:number;

		public autoChange:boolean;

		public margin:number;

		//SP時に1画面表示する個数が変動する場合
		public changeShowNumSp:boolean;
		public showNumSp:number;

		//複数表示時のループ用（クリエイターズ用）
		private isDiv4:boolean;
		private originalNum:number;

		public isScreenIn:boolean;

		public offsetMinY:number;
		public offsetMaxY:number;

		public static rnd:number = 0;

		public myRnd:number;

		private buttons:JQuery;

		private btnLeft:JQuery;
		private btnRight:JQuery;


		constructor(target:string, showNum:number, isLoop:boolean, arrowTarget:string)
		{
			super();

      AppState.addResizeFunc(this.onResize, this);

			this.isLoop = isLoop;

			this.showNumPc = showNum;
      
      this.targetStr = target;// + " ";

			this.margin = 10;

			this.useDeltaTime = true;

			this.timer = 0;

			this.limitTime = 5000;

			this.myRnd = HorizontalScroller.rnd++;

			this.maskArea = $(arrowTarget).find(".scrollMask");

			this.buttons = $(arrowTarget).find(".btnArrow");

			this.btnLeft = $(arrowTarget).find(".left");
			this.btnRight = $(arrowTarget).find(".right");

			this.btnLeft.on("click", ()=>
			{
				this.changePage(-1);
			});
			this.btnRight.on("click", ()=>
			{
				this.changePage(1);
			});
		}


		public start():void
		{
			this.scrollPer = 0;
			this.currentIndex = 0;

			this.updateButton(this.currentIndex);

			if (this.changeShowNumSp)
			{
				if (AppState.isSp)
				{
					this.showNum = this.showNumSp;
				}
				else
				{
					this.showNum = this.showNumPc;
				}
			}
			else
			{
				this.showNum = this.showNumPc;
			}

			this.scrollContainer = new Sprite($(this.targetStr).find(".scrollContainer"));

			this.originalNum = $(this.targetStr + " .item").length;
			this.isDiv4 = false;

			if (this.isLoop)
			{
				//ループの場合はITEMを複製しておく
				//左右行き止まりの際に、ループ出来るようにするため

				const initialItems:JQuery = $(this.targetStr + " .item");

				$(this.targetStr + " .item").each((index:number, elem:Element):void=>
				{
					const newItem:JQuery = $(elem).clone();
					this.scrollContainer.element.append(newItem);
				});

				//クリエイターズのように1画面に数個表示される場合は、
				//2倍の数では足りないためもう1回複製処理をしておく（計4倍）
				if (this.showNum > 1)
				{
					$(this.targetStr + " .item").each((index:number, elem:Element):void=>
					{
						const newItem:JQuery = $(elem).clone();
						this.scrollContainer.element.append(newItem);
					});

					this.isDiv4 = true;
				}
			}

			this.refreshWidth();

			//最大のページ数
			this.maxIndex = $(this.targetStr + " .item").length;
			//this.updateMaxIndex();

			//console.log("maxIndex = " + this.maxIndex);

			this.bar = $(this.targetStr).find(".bar");

			this.indicatorsPc = [];
			this.indicatorsSp = [];

			$(this.targetStr + " .indicatorPc li").each((index:number, elem:Element):void=>
			{
				this.indicatorsPc.push($(elem));
			});
			$(this.targetStr + " .indicatorSp li").each((index:number, elem:Element):void=>
			{
				this.indicatorsSp.push($(elem));
			});

			$(this.targetStr + " .scrollClickArea").on("mouseup", (e:JQueryEventObject)=>
			{
				if (this.locked)
				{
					return;
				}

				if (AppState.isSp)
				{
					return;
				}

				const mouseX:number = (e.originalEvent as MouseEvent).clientX;

				this.stopTimer();

				if (mouseX > (window.innerWidth / 2))
				{
					this.changePage(1);
				}
				else
				{
					this.changePage(-1);
				}
			});
			
			this.updateIndicator();
			this.setDragEvent();
			this.checkLoopAjust();
			this.onResize(false);
			this.startTimer();

			this.showFaderObject();
		}


		public remove():void
		{
			this.stopTimer();
			this.deleteEnterFrame;
			this.bar = null;
			this.scrollContainer.deleteEnterFrame;
			this.scrollContainer.removeAllEventListener();
			this.scrollContainer = null;
			
			$(this.targetStr + " .scrollClickArea").off("mouseup");

			AppState.removeResizeFunc(this.onResize);
		}


		/*
		private updateMaxIndex():void
		{
			if (AppState.isSp)
			{
				this.maxIndex = 4;
			}
			else
			{
				this.maxIndex = 4;
			}
		}
		*/


		/*
		 * showNumの個数が切り替わった場合の
		 * 変数計算
		 */
		private refreshWidth():void
		{
			//スクロールエリアの幅（％）を計算する
			const len:number = $(this.targetStr + " .item").length;

			//アイテム１つあたりの幅（％）
			this.itemWidth = (100 - (this.margin * (this.showNum - 1))) / this.showNum;
			this.scrollBarPer = (this.itemWidth * len) + (this.margin * (len - 1));
			this.scrollContainer.element.css({
				"width": this.scrollBarPer + "%"
			});
			
			$(this.targetStr + " .item").each((index:number, elem:Element):void=>
			{
				if (index == 0)
				{
					$(elem).css({
						"width" : ((this.itemWidth / this.scrollBarPer) * 100) + "%"
					});
				}
				else
				{
					$(elem).css({
						"width" : ((this.itemWidth / this.scrollBarPer) * 100) + "%",
						"margin-left" : ((this.margin / this.scrollBarPer) * 100) + "%"
					});
				}
			});

			this.updateScroll();
		}


		private onResize(isChange:boolean):void
		{
			this.offsetMinY = $(this.targetStr).offset().top;
			this.offsetMaxY = this.offsetMinY + $(this.targetStr).height();

			//console.log(this.myRnd + " min/max = " + this.offsetMinY + " " + this.offsetMaxY);

			//PC/SPで表示個数が切り替わる場合
			if (this.changeShowNumSp)
			{
				if (AppState.isSp)
				{
					this.showNum = this.showNumSp;
				}
				else
				{
					this.showNum = this.showNumPc;
				}

				this.refreshWidth();
			}

			if (isChange)
			{
				//console.log("to " + AppState.isSp);
				//this.updateMaxIndex();
				this.updateIndicator();
			}
			
			if (AppState.isSp)
			{
				const h:number = $(this.targetStr + " .item img").height() / 2 - 16;

				console.log("buttons " + this.buttons.length);

				this.buttons.each((index:number, elem:Element):void=>
				{
					$(elem).css("top", h + "px");
				});
			}

			this.updateScroll();
		}


		private startTimer():void
		{
			if (!this.autoChange)
			{
				return;
			}

			this.timer = 0;

			this.onEnterFrame = (deltaTime:number):void =>
			{
				if (this.isScreenIn)
				{
					this.timer += deltaTime;
	
					let per:number = (this.timer / this.limitTime) * 100;
	
					if (per > 100)
					{
						per = 100;
					}
	
					this.bar.css("width", per + "%");
	
					if (this.timer >= this.limitTime)
					{
						this.deleteEnterFrame;
	
						window.setTimeout(()=>
						{
							this.changePage(1);
						}, 10);
					}
				}
			};
		}


		private stopTimer():void
		{
			this.deleteEnterFrame;
		}


		private changePage(addNum:number):void
		{
			//console.log(this.myRnd + " changePage " + addNum);
			let next = this.currentIndex + addNum;

			if (next < 0 || next >= this.maxIndex)
			{
				return;
			}

			// if (next >= this.maxIndex)
			// {
			// 	next = 0;
			// }


			this.currentIndex = next;

			this.updateButton(next);

			this.updateIndicator();

			//console.log(this.currentIndex);

			const per:number = (this.itemWidth * this.currentIndex) + (this.margin * (this.currentIndex ));

			let sa:number = 0;
			let tmp:number;

			this.locked = true;

			this.scrollContainer.onEnterFrame = (deltaTime:number):void =>
			{
				sa += 0.0045;
				this.scrollPer += tmp =(per - this.scrollPer) * sa;
				this.updateScroll();

				//Debugger.text(0, this.scrollPer);

				if (Math.abs(tmp) < 0.01)
				{
					this.scrollContainer.deleteEnterFrame;
					
					window.setTimeout(()=>
					{
						this.checkLoopAjust();
						this.locked = false;

						this.startTimer();
					}, 10);
				}
			};
		}


		private updateButton(next:number):void
		{
			if (next == 0)
			{
				this.btnLeft.addClass("off");
				this.btnRight.removeClass("off");
			}
			else if (next == (this.maxIndex - 1))
			{
				this.btnLeft.removeClass("off");
				this.btnRight.addClass("off");
			}
			else
			{
				this.btnLeft.removeClass("off");
				this.btnRight.removeClass("off");
			}
		}


		/*
		 * ループの場合は左右の端かどうかチェック
		 */
		private checkLoopAjust():void
		{
			if (this.isLoop)
			{
				if (this.currentIndex == 0)
				{
					this.currentIndex = this.maxIndex / 2;
					this.scrollPer = (this.itemWidth * this.currentIndex) + (this.margin * (this.currentIndex));
					this.updateScroll();
				}
				else if (this.currentIndex == (this.maxIndex - 1))
				{
					this.currentIndex = this.maxIndex / 2 - 1;
					this.scrollPer = (this.itemWidth * this.currentIndex) + (this.margin * (this.currentIndex));
					this.updateScroll();
				}
				else if (this.isDiv4)
				{
					//4倍にしている場合は、もう1段階前の状態から元に戻す
					if (this.currentIndex == this.originalNum)
					{
						this.currentIndex += this.originalNum;//this.maxIndex / 2;
						this.scrollPer = (this.itemWidth * this.currentIndex) + (this.margin * (this.currentIndex));
						this.updateScroll();
					}
					else if (this.currentIndex == (this.maxIndex - (this.originalNum + 1)))
					{
						this.currentIndex -= this.originalNum;	//= this.maxIndex / 2 - 1;
						this.scrollPer = (this.itemWidth * this.currentIndex) + (this.margin * (this.currentIndex));
						this.updateScroll();
					}
				}
			}
		}


		private updateScroll():void
		{
			//this.scrollContainer.updateTranslateXPercent(-(this.scrollPer / this.scrollBarPer) * 100);

			//パーセントで移動させたかったが、ドラッグ時の処理が
			//ピクセル移動じゃないと対処できなかったので、ピクセルベースで基本動かす事。
			const per:number = -(this.scrollPer / this.scrollBarPer);
			const w:number = this.scrollContainer.element.width();
			//console.log(per + " -----5----- " + w);
			this.scrollContainer.x = per * w;
			this.scrollContainer.update();
		}


		private updateIndicator():void
		{
			if (AppState.isSp)
			{
				//console.log("change --> " + this.currentIndex + " " + this.originalNum + " = " + (this.currentIndex % this.originalNum));

				for (var i:number = 0; i < this.indicatorsSp.length; i++)
				{
					this.indicatorsSp[i].removeClass("selected");
					if (i == (this.currentIndex % this.originalNum))
					{
						this.indicatorsSp[i].addClass("selected");
					}
				}
			}
			else
			{
				for (var i:number = 0; i < this.indicatorsPc.length; i++)
				{
					this.indicatorsPc[i].removeClass("selected");
					if (i == (this.currentIndex % this.originalNum))
					{
						this.indicatorsPc[i].addClass("selected");
					}
				}
			}
		}


		/*
		 * 自動切換えではなく、手動スクロールに(スマホ専用)
		 */
		private setDragEvent():void
		{
			//var scope:PeopleSubPage = this;
			$(this.targetStr + " .scrollMask .item").on("touchstart", (e:JQueryEventObject):void =>
			{
				//Debugger.log($((e.originalEvent as TouchEvent).target).prop("tagName"));

				if (!AppState.isSp || this.locked)
				{
					return;
				}
				
				this.stopTimer();

				var offsetX:number = this.scrollContainer.x;
				var offsetTouchX:number = (<TouchEvent>e.originalEvent).touches[0].pageX;
				var offsetTouchY:number = (<TouchEvent>e.originalEvent).touches[0].pageY;
				var curr:number = offsetTouchX;

				//タッチ時は0で、タッチ終了すると1にする
				var sceneIndex:number = 0;
				var dragSpeed:number = 0;

				var nextIndex:number;
				var endFixedPos:number;

				let moveFunc:any;
				
				var isSide:boolean = false;
				var isWindowScroll:boolean = false;

				//タッチ終了時イベント
				$(window).on("touchend", (e2:JQueryEventObject):void =>
				{
					//指が離れたので、どの写真にいくか判断

					AppState.scrollLock = false;

					//Debugger.log(dragSpeed);

					if (dragSpeed < -10)
					{
						nextIndex = this.currentIndex + 1;

						if (nextIndex >= this.maxIndex)
						{
							nextIndex = this.maxIndex - 1;
						}
					}
					else if (dragSpeed > 10)
					{
						nextIndex = this.currentIndex - 1;

						if (nextIndex < 0)
						{
							nextIndex = 0;
						}
					}
					else
					{
						nextIndex = this.currentIndex;
					}

					
					this.scrollPer = (100 * nextIndex) + (this.margin * (nextIndex));
					const per:number = -(this.scrollPer / this.scrollBarPer);
					const w:number = this.scrollContainer.element.width();
					//this.scrollContainer.x = per * w;

					//const w:number = $(this.targetStr + ".scrollMask .item").width();
					endFixedPos = per * w;
					this.currentIndex = nextIndex;
					//this.scrollPer = (100 / this.maxIndex) * this.currentIndex;

					$(this.targetStr + " .indicatorSp li").each((index:number, elem:Element):void =>
					{
						if (index == this.currentIndex)
						{
							$(elem).addClass("selected");
						}
						else
						{
							$(elem).removeClass("selected");
						}
					});

					this.updateIndicator();
					this.updateButton(this.currentIndex);

					sceneIndex = 1;

					$(window).off("touchend");
					//$(window).off("touchmove");
					window.removeEventListener("touchmove", moveFunc);

					if (isWindowScroll || isSide)
					{
						e2.preventDefault();
					}
				});
				//-------------- touch end
				

				//タッチムーブイベント
				//最初の初動の位置によって、縦方向か横方向か、いずれかの動きに制限する

				//18.08.06 
				//passive : falseにしないとエラーが出るため
				//addEventListenerでイベントセット
				//jQueryのonだとpassiveの設定が出来ないようなので。
				//イベント削除は$().offで消えるっぽい
				window.addEventListener("touchmove", moveFunc = (e3:TouchEvent)=>
				{
					//Debugger.text(0, "isWindowScroll " + isWindowScroll);
					//Debugger.text(1, "isSide " + isSide);
					
					if (isWindowScroll) 
					{
						return;
					}

					if (isSide)
					{
						e3.preventDefault();
						
						curr = e3.touches[0].pageX;
					}
					else
					{
						var moveX:number = e3.touches[0].pageX;
						var moveY:number = e3.touches[0].pageY;

						var r:number = Math.atan2(moveY - offsetTouchY, moveX - offsetTouchX) * 180 / Math.PI;
						if (r < 0)
						{
							r += 360;
						}
						if ((r < 45 || ((r > 135) && (r < 225)) || r > 315))
						{
							isSide = true;
							e.preventDefault();
							AppState.scrollLock = true;
							return false;
						}
						else
						{
							isWindowScroll = true;
						}
					}
				}, { passive : false });

				var currX:number = curr;//offsetX + curr - offsetTouchX;

				var dragLimit:number = 70;
				var tmp:number;
				var sa:number = 0;

				this.scrollContainer.onEnterFrame = ():void =>
				{
					switch(sceneIndex)
					{
						case 0:
							//ドラッグ時のモーション
							dragSpeed = curr - currX;
							currX = curr;

							var per:number = Math.max(0, Math.min(1, (dragLimit - Math.abs(this.scrollContainer.x - offsetX)) / dragLimit));

							//Debugger.text(1, this.scrollContainer.x + " " + offsetX + " " + dragLimit);

							this.scrollContainer.x += dragSpeed * per;
							this.scrollContainer.update();
							break;
						case 1:
							sa += 0.015;
							this.scrollContainer.x += tmp = (endFixedPos - this.scrollContainer.x) * sa;

							if (Math.abs(tmp) < 0.001)
							{
								this.scrollContainer.x = endFixedPos;
								this.scrollContainer.deleteEnterFrame;
								this.startTimer();
								//Debugger.log("delete!");
							this.scrollContainer.update();
							this.checkLoopAjust();
							}
							else
							{
								this.scrollContainer.update();
							}


							break;
						default:break;
					}
				};
			});
		}
	}
}

